import { graphql } from "@/graphql/codegen/gql.ts"

graphql(`
  mutation AddPaymentTermsMutation($input: PaymentTermCreateInput!) {
    paymentTerm {
      create(input: $input) {
        ... on PaymentTermCreateSuccess {
          paymentTerm {
            paymentTermId
            name
            createdOn
            updatedOn
          }
        }
        ... on PaymentTermCreateFailure {
          error {
            message
          }
        }
      }
    }
  }
`)

graphql(`
  mutation UpdatePaymentTermsMutation($input: PaymentTermUpdateInput!) {
    paymentTerm {
      update(input: $input) {
        ... on PaymentTermUpdateSuccess {
          paymentTerm {
            paymentTermId
            name
            createdOn
            updatedOn
          }
        }
        ... on PaymentTermUpdateFailure {
          error {
            message
          }
        }
      }
    }
  }
`)
